import { StockResponse } from "../types/capsule-ticker-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

export const getIndices = async (): Promise<IResponse<StockResponse>> => {
  const response = await request<StockResponse>({
    method: "POST",
    url: `${API_PATHS.indicesData}`,
    data: {
      entity: "mkt_today",
      page: 1,
      limit: 10,
    },
  });
  return response;
};
